import React, { useState, useEffect } from "react";
import axios from "axios";
import { GoogleMap, useJsApiLoader, Marker, OverlayView } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "70vh",
};

const center = {
    lat: 28.5116,  // Default latitude
    lng: 77.2878,  // Default longitude
};

const GoogleMapComponent = ({ lat_long = "28.5116 77.2878" }) => {
    const [equipments, setEquipments] = useState([]);
    const [loading, setLoading] = useState(false);

    // const [lat, lng] = lat_long.split(' ').map(Number);
    // Ensure lat_long is a string and can be split
    const [lat, lng] = (typeof lat_long === "string" ? lat_long : "28.5116 77.2878")
        .split(" ")
        .map(Number);
    if(lat != 0){
        const center = { lat, lng };
    }
    // ✅ Use `useJsApiLoader` to ensure Google Maps API is loaded
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDPMF7fzNp0C0PJbwtSFQNf1icTv2ceO4c",
    });

      const CustomMarker = ({ position, number }) => {
            return (
                <OverlayView
                    position={position}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "30px",
                            height: "40px",
                            backgroundImage: "url(/pointer.png)",
                            backgroundSize: "cover",
                            textAlign: "center",
                            lineHeight: "50px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "white",
                            // borderRadius: "5%",
                            // border: "2px solid blue",
                        }}
                    >
                        {number}
                    </div>
                </OverlayView>
            );
        };

    if (!isLoaded) return <p>Loading map...</p>;

    return (
        <>
            <div className="" >
                {/* <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17.5} mapTypeId="satellite">
                    <Marker
                        position={center}
                        icon={{
                            url: "/rst.png",
                            scaledSize: new window.google.maps.Size(50, 50),
                        }}
                    />

                </GoogleMap> */}
                <div>
                    {/* <a href="/">Back</a> */}
                <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17.5} mapTypeId="satellite">
                    {/* <Marker
                        position={center}
                        icon={{
                            url: "/rst.png",
                            scaledSize: new window.google.maps.Size(100, 100),
                        }}
                    /> */}

                    <CustomMarker position={{ lat: parseFloat(lat), lng: parseFloat(lng) }} number={''} />

                    {/* Dynamic Markers */}
                    {/* {equipments.map((equipment, index) => (
                    ))} */}
                </GoogleMap>
            </div>   
            </div>

        </>
    );
};

export default GoogleMapComponent;
